import { GLDistributionTable } from "../GLDistributionTable";
import { Checkbox, DataHeader, DataSource, Layout, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSettlement401kHistory extends Layout {
    checkboxIsVoid: Checkbox;
    dataheaderSettlement401kHistory: DataHeader;
    layoutGLDistribution: GLDistributionTable;
    sourceDrs401kHist: DataSource;
    sourceJournalDriver: DataSource;
    tabGLDistribution: Tab;
    tabGeneral: Tab;
    tabsetSettlement401kHistory: Tabset;
    textboxCheckNumber: Textbox;
    textboxContribType: Textbox;
    textboxContribution: Textbox;
    textboxDeductionDate: Textbox;
    textboxDeductionId: Textbox;
    textboxFundId: Textbox;
    textboxMatchingAmount: Textbox;
    textboxPayeeId: Textbox;
    textboxVoidDate: Textbox;
}
